// extracted by mini-css-extract-plugin
export var selectedChip = "search-filter-chip-module--selectedChip--S072I";
export var unselectedChip = "search-filter-chip-module--unselectedChip--3BZ3J";
export var title = "search-filter-chip-module--title--1XwIL";